<div class="container">
  <h1 class="page-title">Agency Overview</h1>
  <!--section-->
  <section class="widget">
    <div class="widget-body">
      <div class="mt">
        <!--form-->
        <form class="form-horizontal" [formGroup]="form" novalidate>
          <!--Agency-->
          <div class="row form-group">
            <label class="col-md-2"><strong>Agency:</strong></label>
            <div class="col-md-10">
              <!--Name-->
              <div class="row form-group" [class.has-danger]="!agencyName.valid && agencyName.touched">
                <span class="required-label col-md-2">Name</span>
                <div class="col-md-9">
                  <input [formControl]="agencyName" class="form-control" type="text"
                         formControlName="agencyName"
                         placeholder="Agency Name">
                </div>
              </div>
              <!--Status-->
              <div class="row form-group" [class.has-danger]="!status.valid && status.touched">
                <span class="required-label col-md-2">Status</span>
                <div class="col-md-9">
                  <select [formControl]="status" required class="form-select"
                          formControlName="status">
                    <option value="null">Choose a Status</option>
                    <option *ngFor="let enumValue of statuses" [value]="enumValue.key">{{enumValue.key}}</option>
                  </select>
                </div>
              </div>
              <!--CssCode-->
              <div class="row form-group" [class.has-danger]="!amerenCssCode.valid && amerenCssCode.touched">
                <span class="col-md-2">Ameren CSS</span>
                <div class="col-md-9">
                  <input [formControl]="amerenCssCode"
                         class="form-control"
                         type="text"
                         formControlName="amerenCssCode"
                         placeholder="Ameren CSS">
                </div>
              </div>
              <!--is efn-->
              <div class="row form-group" [class.has-danger]="!isEfnAgency.valid && isEfnAgency.touched">
                <span class="col-md-2">Is EFN Agency</span>
                <div class="col-md-9">
                  <input [formControl]="isEfnAgency"
                         type="checkbox"
                         class="form-check-input"
                         formControlName="isEfnAgency"
                         id="isEfnAgency">
                </div>
              </div>
              <div class="row form-group" *ngIf="isEfnAgency.value">
                <span class="col-md-2">EFN Zones</span>
                <div class="col-md-9">
                  <efnZoneCheckbox [control]="efnZones"></efnZoneCheckbox>
                </div>
              </div>
            </div>
          </div>
          <!--PledgeTypes-->
          <div class="row form-group">
            <label class="col-md-2"><strong>Fund Types:</strong></label>
            <div class="col-md-10">
              <!--check-box-->
              <div class="row" [class.has-danger]="!pledgeTypeIds.valid && pledgeTypeIds.touched">
                <span class="col-md-2"></span>
                <div class="col-md-9">
                  <pledgeTypeCheckbox [control]="pledgeTypeIds" [showDisabled]="true"></pledgeTypeCheckbox>
                </div>
              </div>
            </div>
          </div>
          <!--submit-->
          <div class="row w-100 form-group">
              <div class="display-flex flex-row w-100 justify-content-end">
                  <!--delete-->
                  <button type="button"
                          class="btn btn-inverse me-4"
                          (click)="showPromptModal()">Delete Agency
                  </button>
                  <!--save-->
                  <button [disable]="isValidSave()"
                          [autoDisable]="submit"
                          type="submit"
                          class="btn btn-primary me-2">Save Agency
                  </button>
                <cancel-button class="p-l-1 pull-right" [route]="'/app/agencies'"></cancel-button>

              </div>
          </div>
        </form>
      </div>
    </div>
    <prompt-dialog
      [titleText]="'Delete Agency?'"
      [promptText]="'Are you sure you want to delete this agency?'">
    </prompt-dialog>
  </section>
</div>
